<template>
  <div class="error-generic">
    <v-alert :type="type" :dismissible="dismissible" v-model="showAlert" :class="'text-'+ alignment">
      <slot>Unable to load content</slot>
      <strong>{{ message }}</strong>
      <p class="bottom" v-if="showReload">
        <a href="#" @click.prevent="reload">Reload the page</a> to try again.
      </p>
    </v-alert>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        showAlert: true
      }
    },
    props: {
      alignment: {
        type: String,
        default: 'center'
      },
      dismissible: {
        type: Boolean,
        default: true
      },
      type: {
        type: String,
        default: 'warning'
      },
      showReload: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      reload () {
        window.location.reload(false)
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .error-generic
    margin-top: 20px
    margin-bottom: 20px
</style>



// WEBPACK FOOTER //
// frontend/src/components/common/ErrorGeneric.vue